
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import AboutSection from './components/AboutSection';
import ClientsSection from './components/ClientsSection';
import PurposeSection from './components/PurposeSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20">
        <HeroSection />
        <ServicesSection />
        <ProcessSection />
        <AboutSection />
        <ClientsSection />
        <PurposeSection />
        <ContactSection />
      </div>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/5531972176645?text=Olá! Gostaria de falar com vocês sobre precatórios."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full shadow-lg z-50 transition-all duration-300 transform hover:scale-110 flex items-center justify-center animate-pulse"
      >
        <i className="ri-whatsapp-fill text-2xl"></i>
      </a>
    </div>
  );
}
